<template>
  <v-app-bar elevation="0" dense outlined fixed>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col class="d-flex align-center justify-space-around" cols="10">
          <p v-bind:key="item.path" v-for="item in items" @click="option(item)"
            :class="(item.path === itemSelected) ? 'selected-option' : 'normal-option'">
            {{ item.title }}
            <v-icon class="ml-1" x-small>fa-regular {{ item.icon }}</v-icon>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "TopNavbar",
  data() {
    return {
      name: this.$store.state.user.name,
      items: [],
      itemSelected: '/dashboard',
    };
  },
  watch: {
    '$store.state.whitelabel.features': function () {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.items = [
        { value: 'DASHBOARD', title: this.$t('items_TopNavbar.tableDashboard'), icon: 'fa-tachometer-alt', path: '/dashboard', beta: false },
        { value: 'WATCHLIST', title: this.$t('items_TopNavbar.tableWatchlist'), icon: 'fa-binoculars', path: '/watchlist', beta: false },
        { value: 'JOURNAL', title: this.$t('items_TopNavbar.tableJournal'), icon: 'fa-stream', path: '/journal', beta: false },
        { value: 'MENTOR', title: this.$t('items_TopNavbar.tableMentor'), icon: 'fa-brain', path: '/mentor', beta: true },
        { value: 'PLAN', title: this.$t('items_TopNavbar.tablePlan'), icon: 'fa-swatchbook', path: '/plan', beta: false },
        { value: 'FUNDING_HUNT', title: this.$t('items_TopNavbar.tableFunding'), icon: 'fa-search-dollar', path: '/funding-simulation', beta: false },
        { value: 'TOURNAMENTS', title: this.$t('items_TopNavbar.tableTournaments'), icon: 'fa-trophy', path: '/tournaments', beta: false },
        { value: 'COMMUNITY', title: this.$t('items_TopNavbar.tableCommunity'), icon: 'fa-users', path: '/community', beta: false },
      ];

      this.items = this.items.filter((item) =>
        this.$store.state.whitelabel.features.findIndex((feature) =>
          feature.feature.name === item.value) !== -1);
    },
    option(item) {
      this.itemSelected = item.path;
      this.$router.push(item.path);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/global";


.v-app-bar.v-toolbar.v-sheet{
  background-color: var(--v-baseBackground-base) !important;
}
.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background-color: var(--v-baseBackground-base) !important;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background-color: var(--v-baseBackground-base) !important;
}

#app {
  .normal-option {
    margin-bottom: 0;
    font-size: 14px;
    max-width: 10vw !important;
    cursor: pointer;

    .v-icon {
      color: inherit;
    }
  }

  .selected-option {
    color: var(--v-brandPrimary-base) !important;
    margin-bottom: 0;
    font-size: 14px;
    max-width: 10vw !important;
    cursor: pointer;

    .v-icon {
      color: inherit;
    }
  }

}
</style>

